import { iam } from '@myap/ui-library/esm/profile'

/**
 * Request settings for API Gateway calls, which authenticate with the current Catapult
 * session rather than an API key. Called per request so the tokens are always current.
 */
export const apiGatewayRequestSettings = () => {
  const { getAuthSession, getJWTToken } = iam()
  return {
    withCredentials: false,
    headers: {
      'X-CB-Catapult-Authentication-Token': getAuthSession().sessionId,
      'X-CB-Catapult-Authorization-Token': getJWTToken(),
    },
  }
}

export default apiGatewayRequestSettings
